<section class="seo-service">
    <div class="container-fluid">
        <div class="row center-align">          
            <div class="col-md-6">
                <div class="service">
                    <h2>
                        Codesroots تساعدك على الحصول على تطبيقات سطح المكتب والتى تهدف الى :
                    </h2>
                    <ul class="fa-ul text-right">
                        <li>                      
                            التقليل من العمل الورقى وتحويله إلى عمل ألكتروني وذلك باستخدام أحدث ما توصل اليه العلم فى التكنولوجيا الحديثة
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            تقليل الوقت والتكلفة التى تلزم ﻻنجاز اﻻعمال داخل المنظمة التى يتم التعامل معها
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            رفع كفائة اﻻعمال
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>
                        <li>                      
                            وضع خطة عمل لتحديد النظام اﻻلكترونى اﻷنسب للمشروع أو الشركة أو الهيئة أو المؤسسة التى يتم التعامل معها طبقا للميزانية المتاحة بأقل تكاليف ممكنة مع الحفاظ على جودة النظام
                          <span class="fa-li"><i class="fas fa-check"></i></span>
                        </li>                                                                                                                      
                    </ul>
                </div>                
            </div>
            <div class="col-md-6 text-center">
                <img src="./../../../assets/images/desktop-image-3.png" alt="seo" />
            </div>              
        </div>
    </div>
</section>